import React from 'react';

const JS_Comparisons = () => {
  return (
    <div >
      <h1>JS_Comparisons</h1>
      <p>Placeholder component for: "JS Comparisons"</p>
    </div>
  );
};

export default JS_Comparisons;
